import React from 'react';

export const NAComponent = () => <span className="text-muted">n/a</span>;
